import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { styled } from 'styled-components';
import { Box } from "../../../box/src";
import { Dotdotdot } from "../../../dotdotdot/src";
import { FlagStatus, STATUS } from "../../../flag/src";
import { Image } from "../../../image/src";
import { Link } from "../../../link/src";
import { useBreakpoint } from "../../../theme/src";
import { UsersAvatarList } from "../../../users-avatar-list/src";
const VARIANTS = Object.freeze({
    withDetails: {
        imageMarginBottom: { _: 3, m: 0 },
        imageMaxWidth: { _: '222px', m: '210px' },
        imageMinHeight: { _: '119px', m: '108px' },
        rowFlexDirection: { _: 'column', m: 'row' },
        rowHeight: { _: 'auto', m: '118px' },
        rowMarginBottom: { default: 6, last: 0 },
    },
    withoutDetails: {
        imageMarginBottom: 0,
        imageMaxWidth: '145px',
        imageMinHeight: '74px',
        rowFlexDirection: { _: 'row', m: 'row' },
        rowHeight: { _: 'auto', m: '78px' },
        rowMarginBottom: { default: 5, last: 0 },
    },
});
const EventImageContainer = (_a) => {
    var { children, clickableProps, path } = _a, imageProps = __rest(_a, ["children", "clickableProps", "path"]);
    return path ? (_jsx(EventImageWrapper, Object.assign({}, imageProps, { children: _jsx(Link, { display: "flex", styledOnlyOnHover: true, tabIndex: -1, to: path, width: "100%", children: children }) }))) : (_jsx(EventImageWrapper, Object.assign({}, clickableProps, imageProps, { children: children })));
};
export const EventPresentation = ({ attendees, cancelled, cancelledText = 'Canceled', date, formattedDate, image, isLast, location, name, onClick, path, publishedLabel, seeMoreOnClick, totalAttendees, withDetails, }) => {
    const [cardHovered, setCardHovered] = useState(false);
    const breakpoint = useBreakpoint();
    const clickableProps = useMemo(() => onClick && {
        onClick,
        onMouseEnter: () => setCardHovered(true),
        onMouseLeave: () => setCardHovered(false),
    }, [onClick]);
    const { imageMarginBottom, imageMaxWidth, rowFlexDirection, rowHeight, rowMarginBottom, } = withDetails ? VARIANTS.withDetails : VARIANTS.withoutDetails;
    const withDetailsClamp = date && publishedLabel && location ? 1 : 2;
    const eventNameClamp = withDetails ? withDetailsClamp : 2;
    return (_jsxs(EventPresentationCard, { flexDirection: rowFlexDirection, height: rowHeight, mb: isLast ? rowMarginBottom.last : rowMarginBottom.default, children: [_jsxs(EventImageContainer, { clickableProps: clickableProps, height: "100%", maxWidth: imageMaxWidth, mb: imageMarginBottom, minWidth: imageMaxWidth, path: path, children: [_jsx(Image, { alt: "", height: "100%", src: image, style: { objectFit: 'cover', opacity: cancelled ? 0.4 : 1 }, width: "100%" }), _jsxs(Calendar, { children: [_jsx(Box, { color: "black", font: "h4-semibold", children: formattedDate.day }), _jsx(Box, { color: "asphalt", font: "metadata-regular-asphalt", children: formattedDate.month })] }), withDetails && cancelled && (_jsx(Box, { m: 2, position: "absolute", children: _jsx(FlagStatus, { status: STATUS.ERROR, text: cancelledText }) }))] }), _jsxs(EventDetailWrapper, { children: [path ? (_jsx(EventName, { children: _jsx(Link, { font: "h4-semibold", styledOnlyOnHover: true, to: path, width: "100%", children: _jsx(Dotdotdot, { clamp: breakpoint === 's' ? 3 : eventNameClamp, children: name }) }) })) : (_jsx(EventName, Object.assign({ "$cardHovered": cardHovered }, clickableProps, { children: _jsx(Dotdotdot, { clamp: breakpoint === 's' ? 3 : eventNameClamp, children: name }) }))), withDetails && (_jsxs(_Fragment, { children: [_jsx(Box, { children: date }), _jsx(Box, { children: _jsx(Dotdotdot, { clamp: 1, children: location }) }), publishedLabel && (_jsx(Box, { children: _jsx(Dotdotdot, { clamp: 1, children: publishedLabel }) })), _jsx(Box, { mb: "6px" })] })), _jsx(UsersAvatarList, { maxAvatars: 3, onClickMore: seeMoreOnClick, totalUsers: totalAttendees, users: attendees })] })] }));
};
const EventImageWrapper = styled(Box).attrs({
    mr: 5,
    width: '100%',
}) `
  border-radius: ${({ theme }) => `${theme.themeVariables.globalBorderRadius}px`};
  overflow: hidden;
  aspect-ratio: 210/108;
  &:hover {
    cursor: pointer;
  }
`;
const Calendar = styled(Box).attrs({
    alignItems: 'center',
    alignSelf: 'flex-end',
    bg: 'white',
    flexDirection: 'column',
    m: 2,
    minWidth: '40px',
    p: 1,
}) `
  border-radius: 4px;
  position: absolute;
`;
const EventDetailWrapper = styled(Box).attrs({
    flexDirection: 'column',
    flexGrow: 1,
    justifyContent: 'center',
}) ``;
const EventPresentationCard = styled(Box).attrs({ width: '100%' }) ``;
const EventName = styled(Box).attrs({
    font: 'h4-semibold',
    mb: 1,
}) `
  color: ${({ $cardHovered, theme }) => $cardHovered ? theme.colors.link : 'inherit'};
  line-height: 22px;
  text-decoration: ${({ $cardHovered }) => $cardHovered ? 'underline' : 'none'};
  &:hover,
  &:focus {
    cursor: pointer;
  }
`;
//# sourceMappingURL=EventPresentation.js.map